module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(1), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "a1"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("1")])], 1), _vm._v(" JANUARY")])]), _vm._m(2), _vm._m(3), _vm._m(4), _c('h1', [_c('a', {
    attrs: {
      "id": "a-1"
    }
  }), _c('a', {
    attrs: {
      "id": "a2"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("2")])], 1), _vm._v(" JANUARY")])]), _vm._m(5), _vm._m(6), _vm._m(7), _vm._m(8), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _c('a', {
    attrs: {
      "id": "a3"
    }
  }), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("3")])], 1), _vm._v(" JANUARY")])]), _vm._m(9), _vm._m(10), _vm._m(11), _c('h1', [_c('a', {
    attrs: {
      "id": "a-3"
    }
  }), _c('a', {
    attrs: {
      "id": "a4"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("4")])], 1), _vm._v(" JANUARY")])]), _vm._m(12), _vm._m(13), _vm._m(14), _c('h1', [_c('a', {
    attrs: {
      "id": "a-4"
    }
  }), _c('a', {
    attrs: {
      "id": "a5"
    }
  }), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("5")])], 1), _vm._v(" JANUARY")])]), _vm._m(15), _vm._m(16), _vm._m(17), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the grapefruit segments and juice to the blender. Purée until smooth. Pour into a nonreactive bowl, cover, and refrigerate for 2–3 hours until well chilled.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the chilled grapefruit mixture into an ice-cream maker and freeze according to the manufacturer’s directions. If desired, pack it into a freezer-safe container and freeze until very firm before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "id": "a6"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("6")])], 1), _vm._v(" JANUARY")])]), _vm._m(19), _vm._m(20), _vm._m(21), _c('h1', [_c('a', {
    attrs: {
      "id": "a-6"
    }
  }), _c('a', {
    attrs: {
      "id": "a7"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("7")])], 1), _vm._v(" JANUARY")])]), _vm._m(22), _vm._m(23), _vm._m(24), _c('h1', [_c('a', {
    attrs: {
      "id": "a-7"
    }
  }), _c('a', {
    attrs: {
      "id": "a8"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("8")])], 1), _vm._v(" JANUARY")])]), _vm._m(25), _vm._m(26), _vm._m(27), _c('h1', [_c('a', {
    attrs: {
      "id": "a-8"
    }
  }), _c('a', {
    attrs: {
      "id": "a9"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("9")])], 1), _vm._v(" JANUARY")])]), _vm._m(28), _vm._m(29), _vm._m(30), _vm._m(31), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "a10"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("10")])], 1), _vm._v(" JANUARY")])]), _vm._m(32), _vm._m(33), _vm._m(34), _c('h1', [_c('a', {
    attrs: {
      "id": "a-10"
    }
  }), _c('a', {
    attrs: {
      "id": "a11"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("11")])], 1), _vm._v(" JANUARY")])]), _vm._m(35), _vm._m(36), _vm._m(37), _c('h1', [_c('a', {
    attrs: {
      "id": "a-11"
    }
  }), _c('a', {
    attrs: {
      "id": "a12"
    }
  }), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("12")])], 1), _vm._v(" JANUARY")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._m(40), _c('h1', [_c('a', {
    attrs: {
      "id": "a-12"
    }
  }), _c('a', {
    attrs: {
      "id": "a13"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("13")])], 1), _vm._v(" JANUARY")])]), _vm._m(41), _vm._m(42), _vm._m(43), _c('h1', [_c('a', {
    attrs: {
      "id": "a-13"
    }
  }), _c('a', {
    attrs: {
      "id": "a14"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("14")])], 1), _vm._v(" JANUARY")])]), _vm._m(44), _vm._m(45), _vm._m(46), _c('h1', [_c('a', {
    attrs: {
      "id": "a-14"
    }
  }), _c('a', {
    attrs: {
      "id": "a15"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("15")])], 1), _vm._v(" JANUARY")])]), _vm._m(47), _vm._m(48), _vm._m(49), _vm._m(50), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('a', {
    attrs: {
      "id": "a16"
    }
  }), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("16")])], 1), _vm._v(" JANUARY")])]), _vm._m(51), _vm._m(52), _vm._m(53), _c('h1', [_c('a', {
    attrs: {
      "id": "a-16"
    }
  }), _c('a', {
    attrs: {
      "id": "a17"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("17")])], 1), _vm._v(" JANUARY")])]), _vm._m(54), _vm._m(55), _vm._m(56), _vm._m(57), _c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "a18"
    }
  }), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("18")])], 1), _vm._v(" JANUARY")])]), _vm._m(58), _vm._m(59), _vm._m(60), _c('h1', [_c('a', {
    attrs: {
      "id": "a-18"
    }
  }), _c('a', {
    attrs: {
      "id": "a19"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("19")])], 1), _vm._v(" JANUARY")])]), _vm._m(61), _vm._m(62), _vm._m(63), _c('h1', [_c('a', {
    attrs: {
      "id": "a-19"
    }
  }), _c('a', {
    attrs: {
      "id": "a20"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("20")])], 1), _vm._v(" JANUARY")])]), _vm._m(64), _vm._m(65), _vm._m(66), _c('h1', [_c('a', {
    attrs: {
      "id": "a-20"
    }
  }), _c('a', {
    attrs: {
      "id": "a21"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("21")])], 1), _vm._v(" JANUARY")])]), _vm._m(67), _vm._m(68), _vm._m(69), _c('h1', [_c('a', {
    attrs: {
      "id": "a-21"
    }
  }), _c('a', {
    attrs: {
      "id": "a22"
    }
  }), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("22")])], 1), _vm._v(" JANUARY")])]), _vm._m(70), _vm._m(71), _vm._m(72), _c('h1', [_c('a', {
    attrs: {
      "id": "a-22"
    }
  }), _c('a', {
    attrs: {
      "id": "a23"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("23")])], 1), _vm._v(" JANUARY")])]), _vm._m(73), _vm._m(74), _vm._m(75), _vm._m(76), _c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "id": "a24"
    }
  }), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("24")])], 1), _vm._v(" JANUARY")])]), _vm._m(77), _vm._m(78), _vm._m(79), _c('h1', [_c('a', {
    attrs: {
      "id": "a-24"
    }
  }), _c('a', {
    attrs: {
      "id": "a25"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("25")])], 1), _vm._v(" JANUARY")])]), _vm._m(80), _vm._m(81), _vm._m(82), _c('h1', [_c('a', {
    attrs: {
      "id": "a-25"
    }
  }), _c('a', {
    attrs: {
      "id": "a26"
    }
  }), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("26")])], 1), _vm._v(" JANUARY")])]), _vm._m(83), _vm._m(84), _vm._m(85), _c('h1', [_c('a', {
    attrs: {
      "id": "a-26"
    }
  }), _c('a', {
    attrs: {
      "id": "a27"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("27")])], 1), _vm._v(" JANUARY")])]), _vm._m(86), _vm._m(87), _vm._m(88), _c('h1', [_c('a', {
    attrs: {
      "id": "a-27"
    }
  }), _c('a', {
    attrs: {
      "id": "a28"
    }
  }), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("28")])], 1), _vm._v(" JANUARY")])]), _vm._m(89), _vm._m(90), _vm._m(91), _c('h1', [_c('a', {
    attrs: {
      "id": "a-28"
    }
  }), _c('a', {
    attrs: {
      "id": "a29"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("29")])], 1), _vm._v(" JANUARY")])]), _vm._m(92), _vm._m(93), _vm._m(94), _vm._m(95), _c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('a', {
    attrs: {
      "id": "a30"
    }
  }), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("30")])], 1), _vm._v(" JANUARY")])]), _vm._m(96), _vm._m(97), _vm._m(98), _c('h1', [_c('a', {
    attrs: {
      "id": "a-30"
    }
  }), _c('a', {
    attrs: {
      "id": "a31"
    }
  }, [_c('span', {
    staticClass: "color-1"
  }, [_c('big', [_vm._v("31")])], 1), _vm._v(" JANUARY")])]), _vm._m(99), _vm._m(100), _vm._m(101)]), _c('a', {
    attrs: {
      "id": "a-31"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('h1', {
    staticClass: "head"
  }, [_vm._v("january")]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The first weeks of the new year are a time for hearty soups and easy braises, baked pastas and healthy grain dishes. Market produce aisles are filled with winter crops—brussels sprouts, broccoli, kale, fennel, beets, leeks, and more—and menu choices are varied and satisfying, from red beans and chorizo and polenta topped with chard and mushrooms to a coconut-rich chicken curry anchored with sweet potatoes and carrots. The season’s much-anticipated citrus fruits turn up as well, in salads, in side dishes, and in a pair of irresistible desserts: grapefruit sorbet and lemon chiffon pie")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/cap01#a1"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FENNEL-CRUSTED CHICKEN WITH FENNEL & HERB SALAD")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a2"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SPANISH TORTILLA WITH LEEKS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a3"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SPICED TRI-TIP WITH ROASTED BRUSSELS SPROUTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a4"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-5"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COCONUT RICE NOODLES WITH CRAB & CILANTRO")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a5"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-6"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RUBY GRAPEFRUIT SORBET")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a6"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-7"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BAKED PASTA WITH PROSCIUTTO & PEAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a7"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-8"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SAUTÉED POTATOES WITH CHORIZO & PARSLEY")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a8"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-9"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAI TEA CUPCAKES WITH HONEY CREAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a9"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-10"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TUNA IN ESCABECHE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a10"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-11"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BROCCOLI RABE & OLIVE PIZZA")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a11"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-12"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TOFU SALAD WITH EDAMAME & SHAVED ROOT VEGETABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a12"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-13"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ITALIAN BRAISED SHORT RIBS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a13"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-14"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MAC & CHEESE CHILI")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a14"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-15"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHICKEN & COCONUT CURRY")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a15"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-16"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ROASTED BEETS WITH BABY ARUGULA & RICOTTA SALATA")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a16"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-17"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SALMON CAKES WITH GINGER & GREEN ONION")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a17"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-18"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("POTATO & BROCCOLI SOUP WITH BLUE CHeese")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a18"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-19"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("POLENTA WITH WILD MUSHROOMS, CHARD & CHEDDAR CHEESE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a19"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-20"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SPICY RED BEAN & CHORIZO STEW")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a20"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-21"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ASIAN-STYLE CHICKEN SOUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a21"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-22"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LEMON CHIFFON GINGERSNAP PIE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a22"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-23"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("STIR-FRIED SOBA NOODLES WITH BEEF & CABBAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a23"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-24"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VINEGAR-GLAZED BRUSSELS SPROUTS WITH CHESTNUTS & WALNUT OIL")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a24"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-25"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NOODLE SALAD WITH PORK & ASIAN LIME VINAIGRETTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a25"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-26"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BARLEY RISOTTO WITH CHICKEN, MUSHROOMS & GREENS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a26"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-27"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("KUMQUAT-CARROT PURÉE WITH TOASTED FENNEL SEEDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a27"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-28"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("QUINOA TABBOULEH WITH LEMONY GRILLED SHRIMP")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a28"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-28"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CARAMEL-MACADAMIA TARTLETS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a29"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-29"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FENNEL SALAD WITH BLOOD ORANGES & ARUGULA")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a30"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-30"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SPICED PEAR TARTE TATIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a31"
    }
  }, [_c('span', {
    staticClass: "color-white"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#a-31"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WARM LENTIL & KALE SALAD WITH BACON")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p10.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("An herb and fennel salad is a quick fix for a cool-weather menu that needs color and fresh flavors. A nice break from the more usual lettuce salad, it pairs well here with quickly cooked chicken breasts")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "id": "a-1"
    }
  }, [_vm._v("FENNEL-CRUSTED CHICKEN WITH FENNEL & HERB SALAD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-1"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 2")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ tsp fennel seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ tsp black peppercorns")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("⅛ tsp red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 boneless, skinless chicken breast halves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 tsp extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ small fennel bulb, shaved (about½ cup/2 oz/60 g), plus 1 Tbsp fennel fronds")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp chopped fresh chives")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp fresh flat-leaf parsley leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp fresh lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) dry rosé wine")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) low-sodium chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a mortar using a pestle, grind together the fennel seeds, peppercorns, ¼ tsp salt, and red pepper flakes until coarsely ground.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place 1 chicken breast half between 2 sheets of plastic wrap and pound lightly with a meat mallet until evenly flattened to ½ inch (12 mm) thick. Repeat with the second chicken breast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large frying pan over medium-high heat, warm 2 tsp of the oil. Sprinkle both sides of the chicken breasts evenly with the fennel seed mixture. Cook, turning once, until golden brown on both sides and just cooked through, 3–4 minutes on each side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, stir together the shaved fennel, chives, parsley, fennel fronds, lemon juice, and the remaining oil in a medium bowl and season to taste with salt and black pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer the chicken breasts to warmed plates. Add the wine and broth to the frying pan and simmer until reduced by about half, about 1 minute. Pour the pan juices over the chicken and top each with some of the fennel-herb salad, dividing evenly, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a2"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Spain’s iconic egg-and-potato omelet can be served directly from the frying pan on winter nights or at room temperature on summer days. The tricky part of preparing this dish is flipping the omelet. Iberian cooks typically use a special hinged pan that simplifies the flip. But any large, flat plate or lid, handled carefully, will get the job done")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a2"
    }
  }), _c('a', {
    attrs: {
      "id": "a-2"
    }
  }, [_vm._v("SPANISH TORTILLA WITH LEEKS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-2"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7 Tbsp (3½ fl oz/105 ml) olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ lb (750 g) Yukon Gold potatoes, peeled and cut into slices ⅛ inch (3 mm) thick")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 leek, white and pale green parts, thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 eggs, plus 3 egg whites Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a frying pan, warm 5 Tbsp of the oil over medium-high heat. Add the potatoes and leeks and cook, stirring occasionally, until tender, about 20 minutes. Transfer the potato and leek mixture to a colander to drain. Wipe out the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, beat together the eggs, egg whites, and 1 tsp salt. Gently stir in the potatoes and leeks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the frying pan, warm the remaining 2 Tbsp oil over medium-high heat. Add the potato-egg mixture, press it into a thick cake with a spatula, and cook until set, about 5 minutes, adjusting the heat to prevent scorching. Loosen the tortilla by working the spatula under it, then continue to cook, shaking the pan occasionally, until the bottom is well browned, about 5 minutes more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Slide the tortilla onto a large, flat plate. Invert the pan over it and carefully turn the pan and plate together. Return the pan to the stove top and continue to cook the tortilla until the second side is browned, about 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Slide the tortilla onto a platter and let stand for at least 10 minutes. Cut into wedges and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "a-2"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p13.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tri-tip is a full-flavored cut that remains juicy and moist even when trimmed of fat. Brussels sprouts boast an equally bold flavor to complement the beef. To round out your plate, roast baby potatoes at the same time as the vegetables")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "a-3"
    }
  }, [_vm._v("SPICED TRI-TIP WITH ROASTED BRUSSELS SPROUTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-3"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 lb (1 kg) beef tri-tip, trimmed of fat")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2¼ tsp sweet paprika")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 tsp caraway seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 tsp dried marjoram")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp dry mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ tsp cayenne pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3½ Tbsp olive oil, plus more for brushing")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) brussels sprouts, halved lengthwise")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ lb (375 g) small shallots, halved lengthwise, plus 1 large shallot, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp low-sodium soy sauce, plus 2 tsp")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (4 fl oz/125 ml) dry vermouth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (4 fl oz/125 ml) low-sodium beef or chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 tsp unsalted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 450°F (230°C). Season the beef with salt and pepper, and place on a baking rack set in a shallow roasting pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mix together 2 tsp of the paprika, 1 tsp of the caraway seeds, ½ tsp of the marjoram, the mustard, and cayenne. Mix in 1 Tbsp of the oil, then rub the mixture all over the beef. Oil a large baking pan and add the brussels sprouts, halved shallots, the 1 Tbsp soy sauce, plus the remaining 2½ Tbsp oil, 1 tsp caraway seeds, and 1 tsp marjoram. Mix to coat. Roast the beef and vegetables until an instant-read thermometer inserted in the thickest part of the beef registers 120°F (49°C) for rare, about 20 minutes, or until cooked to your liking. Roast the vegetables until tender and browned, about 25 minutes. Remove the beef from the oven, transfer to a warmed platter, tent with foil, and let rest for 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spoon 1 Tbsp fat from the roasting pan into a saucepan over medium heat; discard the remaining fat. Add the minced shallot to the saucepan and sauté until it begins to soften, about 1 minute. Add the vermouth to the roasting pan, set it over medium-high heat, and bring to a boil, scraping up the browned bits on the pan bottom. Pour the mixture into the saucepan and boil until syrupy, about 3 minutes. Add the broth, remaining ¼ tsp paprika, and 2 tsp soy sauce to the pan. Boil the sauce until syrupy, about 5 minutes. Remove the pan from the heat and pour in any juices from the platter. Whisk in the butter and the remaining ½ tsp marjoram. Season with salt and pepper. Slice the beef and arrange on a warmed platter with the vegetables. Serve with the sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a4"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Using coconut milk is a great way to add natural creaminess and nutrients to a meal. It’s easier to digest than dairy milk and imparts an authentic flavor to Asian noodles. Lime juice and coconut milk are a timeless combination that brings fresh flavor to this dish")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a4"
    }
  }), _c('a', {
    attrs: {
      "id": "a-4"
    }
  }, [_vm._v("COCONUT RICE NOODLES WITH CRAB & CILANTRO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-4"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ lb (250 g) dried flat rice noodles, about¼ inch (6 mm) wide")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) unsweetened coconut milk")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2–3 Tbsp Asian fish sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp fresh lime juice")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grated zest of 1 lime")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2–4 Thai chiles, sliced (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (1 oz/30 g) mung bean sprouts")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ English cucumber, cut into paper-thin slices")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ lb (250 g) fresh lump crabmeat, picked over for shell fragments and cartilage and flaked")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (½ oz/15 g) fresh cilantro leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large pot, bring 4 qt (4 l) water to a rapid boil. Add 1 tablespoon salt and the noodles, stir well, and cook, stirring occasionally, until just tender, 3–5 minutes. Drain in a colander, place under cold running water to cool, and drain again thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a bowl, stir together the coconut milk, fish sauce to taste, lime juice, lime zest, and chiles to taste, if using. Add the bean sprouts, cucumber, and crabmeat and toss gently to mix.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer the noodles to a large, shallow serving bowl. Arrange the crab mixture over the noodles. Scatter the cilantro on top. Serve at room temperature, or cover and refrigerate for up to 3 hours and serve chilled.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Put vibrant ruby grapefruit to good use in this light dessert, which makes a refreshing finish to a hearty winter meal. For an elegant presentation, serve in glasses topped with a splash of prosecco")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "a-5"
    }
  }, [_vm._v("RUBY GRAPEFRUIT SORBET")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-5"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("makes about 1 qt (32 fl oz/1 l)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ cups (12 fl oz/375 ml) fresh grapefruit juice")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1⅓ cups (9 oz/290 g) superfine sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 large ruby or pink grapefruit")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a blender, combine 2 cups (16 fl oz/500 ml) cold water, the grapefruit juice, and sugar.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "a-5"
    }
  }, [_vm._v("Finely grate the zest from the grapefruit and add to the blender. Peel and segment the grapefruit (")]), _c('a', {
    attrs: {
      "href": "#/cap02#page37"
    }
  }, [_vm._v("see recipe")]), _vm._v("), reserving the juices.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a6"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Big pasta tubes are a favorite for tossing with a handful of flavorful ingredients and baking into one-dish meals. Here, the more common rag ù is replaced with strips of prosciutto, peas, and Parmesan mixed into an easy white sauce")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a6"
    }
  }), _c('a', {
    attrs: {
      "id": "a-6"
    }
  }, [_vm._v("BAKED PASTA WITH PROSCIUTTO & PEAS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-6"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (4 oz/125 g) unsalted butter, plus more for greasing")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) ziti, penne, or other tubular pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (2½ oz/75 g) all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 cups (32 fl oz/1 l) milk")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("⅛ tsp grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cups (8 oz/250 g) grated Parmesan cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (5 oz/155 g) frozen petite peas")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ lb (125 g) prosciutto or ham, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (1 oz/30 g) fresh bread crumbs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 425°F (220°C) and butter a 2-qt (2-l) baking dish. Bring a large pot of salted water to a boil. Add the pasta and cook, stirring occasionally, until not quite al dente, about 2 minutes less than the package directions. Drain, rinse with cold water, drain again, and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the same pot, melt the ½ cup butter over medium heat. Add the flour and cook, stirring, for 30 seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Slowly whisk in the milk, and cook, whisking, until the sauce is thick and creamy, 5–10 minutes. Stir in the nutmeg, cheese, peas, and prosciutto. Add the pasta and toss to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer the pasta and sauce to the prepared dish. Sprinkle with the bread crumbs. Bake until the crumbs are golden and the sauce is bubbling, about 20 minutes. Let cool for about 10 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a7"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Humble potatoes are enlivened with a wine reduction, bright parsley, and dry-cured Spanish chorizo. To peel the chorizo, lightly run a sharp knife down its length, then, with your fingers, peel away the skin as if unwrapping the sausage")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a7"
    }
  }), _c('a', {
    attrs: {
      "id": "a-7"
    }
  }, [_vm._v("SAUTÉED POTATOES WITH CHORIZO & PARSLEY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-7"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ lb (750 g) large waxy potatoes, quartered")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (2 oz/60 g) peeled, thinly sliced mild or hot dry-cured chorizo")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (1½ oz/45 g) finely chopped red onion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) dry white wine")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a saucepan, combine the potatoes with water to cover and bring to a boil. Reduce the heat to medium and cook until the potatoes are fork-tender, about 20 minutes. Drain and keep warm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Heat a frying pan over medium-high heat. Add the chorizo and sauté until most of the fat is rendered, about 2 minutes. Pour off the fat and continue cooking the chorizo until lightly browned, 1–2 minutes. Add the onion and sauté for 1 minute. Add the potatoes and wine and cook until most of the liquid evaporates, about 1 minute.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer to a bowl, toss with the parsley, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Traditional chai is a warming cup of milky tea spiked with ginger, cinnamon, cloves, cardamom, and other aromatic spices. This recipe folds those seasonings into a buttermilk batter for cupcakes with a tender crumb and complex flavor. Start with a high-quality tea for the best results")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "a-8"
    }
  }, [_vm._v("CHAI TEA CUPCAKES WITH HONEY CREAM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-8"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("makes 12 cupcakes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 chai tea bags")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1¼ cups (6½ oz/200 g) all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ cup (6 oz/185 g) firmly packed light brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ tsp kosher salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (3 oz/90 g) plus 2 Tbsp honey, plus more for drizzling")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 Tbsp (2 oz/60 g) unsalted butter, melted")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) buttermilk")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 large egg")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (8 fl oz/250 ml) cold heavy cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 350°F (180°C). Line 12 standard muffin cups with paper liners or grease with butter and dust with flour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small bowl, steep the tea bags in ⅔ cup (5 fl oz/160 ml) boiling water for 5 minutes. Discard the bags and let the tea cool to room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a bowl, whisk together the flour, brown sugar, baking soda, and salt. In a large bowl, using an electric mixer, beat together the ¼ cup honey, butter, buttermilk, and egg. Add the dry ingredients and beat just until incorporated, then add the cooled tea and beat just until combined. Divide the batter among the prepared cups, filling them about three-fourths full.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake until a toothpick inserted into the center of a cupcake comes out clean, about 18 minutes. Let cool in the pan on a wire rack for 5 minutes. Transfer the cupcakes to the rack and let cool completely, about 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To make the honey cream, in a chilled bowl, combine the cream and remaining 2 Tbsp honey. Using an electric mixer, beat on low speed until slightly thickened, 1–2 minutes. Gradually increase the speed to medium-high and continue to beat until the cream holds medium peaks, 2–3 minutes. Spread the cupcakes with the honey cream and drizzle with additional honey.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a9"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This popular room-temperature Mediterranean dish pairs meaty fish with a slightly sweet, vinegary sauce. Fragrant with orange zest and garlic, it is finished with just enough red pepper flakes to give it a pleasant bite")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a9"
    }
  }), _c('a', {
    attrs: {
      "id": "a-9"
    }
  }, [_vm._v("TUNA IN ESCABECHE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-9"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Tbsp olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ lb (750 g) albacore or yellowfin tuna fillet, about 1 inch (2.5 cm) thick, cut into 6–8 pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 red bell pepper, seeded and thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ red onion, thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (8 fl oz/250 ml) dry white wine")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ cup (6 fl oz/180 ml) sherry vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cloves garlic, crushed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ tsp black peppercorns")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp grated orange zest")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ tsp red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (2½ oz/75 g) pitted olives")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large frying pan, warm 2 Tbsp of the oil over medium-high heat. Add the tuna and cook, turning once, until browned on both sides but still translucent in the center, 5–8 minutes. Transfer to a 2-qt (2-l) baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the remaining 1 Tbsp olive oil to the pan. Add the bell pepper and onion and sauté until softened, 3–5 minutes. Add the wine, vinegar, garlic, peppercorns, orange zest, sugar, and red pepper flakes. Season with ¾ tsp salt, pour in ¼ cup (2 fl oz/60 ml) water, and bring to a boil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the hot liquid and vegetables over the fish and scatter the olives over the top. Let stand until cooled to room temperature. Cover and refrigerate for at least 8 hours or up to 24 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lift the tuna from the marinade and transfer to a platter. Drain the marinade, reserving the vegetables and olives, and arrange them over the tuna. Let stand for about 15 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "a-9"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p16.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Calorie-laden pizza gets a makeover in this healthy rendition. Part-skim mozzarella keeps the topping creamy but low in fat, and cool-weather broccoli rabe is packed with vitamins and minerals but not calories. Nutty niçoise olives develop a pleasing leathery texture in the oven. The pizza is perfect for lunch or dinner, but, cut into small squares, it also makes an appealing shared snack or appetizer")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('a', {
    attrs: {
      "id": "a-10"
    }
  }, [_vm._v("BROCCOLI RABE & OLIVE PIZZA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-10"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 2–3")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) purchased whole-wheat pizza dough, at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 large clove garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ tsp red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pinch of salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 bunch broccoli rabe, about¾ lb (375 g), thick stems removed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Flour and cornmeal, for dusting")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ lb (250 g) part-skim mozzarella cheese, coarsely shredded")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 oz/60 g) pitted niçoise olives")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Position a rack in the bottom of the oven. Place a baking stone on the rack. Preheat the oven to 550°F (290°C), or the highest setting, for at least 45 minutes. Punch the dough down and turn it out onto a work surface. Shape it into a ball. Cover with a clean kitchen towel and let rest for 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small bowl, combine the oil, garlic, red pepper flakes, and salt. Let stand for 30 minutes to marry the flavors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bring a large pot three-fourths full of salted water to a boil over high heat. Add the broccoli rabe and cook until tender, 2–3 minutes. Drain and cool under running cold water. Gently squeeze out the excess water. Roughly chop the broccoli rabe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To assemble the pizza, lightly flour a work surface. Roll out the dough into a round 13–14 inches (33–35 cm) in diameter. Generously dust a pizza peel or rimless baking sheet with cornmeal and transfer the dough round to it. Working quickly, spread the cheese evenly over the dough, leaving a ¾-inch (2-cm) rim uncovered. Top evenly with the broccoli rabe and the olives. Brush the rim with some of the seasoned oil, then drizzle more oil evenly over the pizza.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Immediately slide the pizza from the peel onto the baking stone. Bake until the crust is crisp and browned, about 8 minutes. Remove from the oven. Brush the rim of the crust with any remaining oil, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a11"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A wonderful mix of contrasting colors, textures, and flavors, this vivid salad is not only fast and simple to make but also healthful and delicious. If you are using boxed tofu, be careful when removing it from the container, as you want the block to remain intact so it can be neatly cubed")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a11"
    }
  }), _c('a', {
    attrs: {
      "id": "a-11"
    }
  }, [_vm._v("TOFU SALAD WITH EDAMAME & SHAVED ROOT VEGETABLES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-11"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ lb (375 g) firm silken tofu, cut into slices 1 inch (2.5 cm) thick")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp light soy sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 tsp toasted sesame oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 green onions, including tender green parts, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1-inch (2.5-cm) piece fresh ginger, peeled and grated")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 watermelon radishes or 6 red radishes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 small celery root (about¾ lb/375 g), peeled and halved lengthwise")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 carrots, peeled and halved crosswise")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cups (12 oz/375 g) frozen shelled edamame")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp sesame seeds, toasted")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Place the tofu in a shallow baking dish. In a small bowl, whisk together the soy sauce, oil, green onions, and ginger. Pour over the tofu and marinate at room temperature for at least 1 hour or up to 3 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, using a mandoline or a very sharp knife, shave the radishes and celery root crosswise. Reserve a few whole shavings for garnish and cut the rest into smaller pieces. Using a vegetable peeler, shave the carrots lengthwise, then cut each ribbon into 3 or 4 pieces. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a saucepan, bring 4 cups (32 fl oz/1 l) water to a boil over medium-high heat. Add ½ tsp salt and the edamame. Reduce the heat to medium and cook until just tender, 5–6 minutes. Drain and rinse with cold water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Divide the edamame among individual plates. Cut the tofu into 1-inch (2.5-cm) cubes. Using a spatula, carefully remove the cubes from the marinade (they are fragile) and place on top of the edamame. Pour a little of the marinade over them. Top with the radish, celery root, and carrot pieces and sprinkle with the sesame seeds. Garnish with the reserved whole vegetable shavings and serve right away.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Meaty short ribs go well with the robust flavors of traditional Italian cooking, and slow cooking coaxes them to fall-off-the-bone tenderness. For an extra flourish, garnish each serving with some of the")]), _vm._v(" gremolata "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("traditionally sprinkled over osso buco (")])]), _c('span', {
    attrs: {
      "href": "#/cap11#page256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("see recipe")]), _vm._v("), and serve atop polenta ("), _c('a', {
    attrs: {
      "href": "#/cap01#page22"
    }
  }, [_vm._v("see recipe")]), _vm._v(").")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a-12"
    }
  }, [_vm._v("ITALIAN BRAISED SHORT RIBS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-12"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Tbsp all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5½–6 lb (2.75–3 kg) beef short ribs, English cut")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 oz (60 g) pancetta, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 yellow onions, finely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 carrots, finely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp tomato paste")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (8 fl oz/250 ml) dry red wine")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 can (14½ oz/455 g) diced tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (8 fl oz/250 ml) beef broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) balsamic vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 sprigs each fresh rosemary and thyme")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp dried oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("On a plate, stir together the flour, 1 tsp salt, and ½ tsp pepper. Turn the ribs in the seasoned flour, shaking off any excess. In a large, heavy pot, heat the oil over medium-high heat. Working in batches, sear the ribs, turning occasionally, until evenly browned, about 10 minutes. Transfer to a plate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the pancetta to the pot and sauté until mostly crisp, 4–5 minutes. Add the onions and sauté until beginning to soften, about 3 minutes. Stir in the garlic and red pepper flakes and sauté until fragrant, about 30 seconds. Add the carrots, tomato paste, and sugar and cook, stirring often, until well blended, about 1 minute. Add the wine, bring to a boil, and stir to scrape up any browned bits on the pan bottom. Stir in the tomatoes and their juices, broth, and vinegar and bring to a boil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 350°F (180°C). Return the ribs to the pot with the tomato mixture. Add the bay leaves, rosemary and thyme sprigs, and oregano. Cover and cook in the oven until the ribs are very tender, about 2 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Skim as much fat as possible from the cooking liquid and discard the bay leaves. Season with salt and pepper and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a13"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Here’s a dish that can be prepared a couple of days in advance and stored, tightly covered, in the refrigerator. You can experiment with the flavors by using crumbled spicy sausage or ground turkey in place of the beef or by trading out the Monterey jack for pepper jack. Pasta-based dishes tend to absorb any liquid they contain when they sit, so be sure to have extra broth on hand to adjust the consistency as needed. To add vegetables to this meal, serve the chili atop a bed of sautéed kale in shallow bowls")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a13"
    }
  }), _c('a', {
    attrs: {
      "id": "a-13"
    }
  }, [_vm._v("MAC & CHEESE CHILI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-13"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ yellow onion, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cloves garlic, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ lb (375 g) lean ground beef")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp chili powder")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ tsp ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 can (14½ oz/455 g) fire-roasted diced tomatoes with juices")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 can (16 oz/500 g) pinto beans, drained")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 cups (32 fl oz/1 l) chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cups (7 oz/220 g) elbow macaroni")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (2 oz/60 g) shredded sharp Cheddar cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (2 oz/60 g) shredded Monterey jack cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 green onions, white and tender green parts, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large, heavy pot, warm the oil over medium-high heat. Add the yellow onion and cook, stirring occasionally, until translucent, about 6 minutes. Add the garlic and cook, stirring occasionally, until soft, about 2 minutes. Add the ground beef and cook, breaking it up with a wooden spoon, until browned, about 5 minutes. Stir in the chili powder, cumin, and ¼ tsp salt. Add the tomatoes with their juices, the beans, and broth and bring to a boil. Add the macaroni, cover, and reduce the heat to medium. Cook until the pasta is al dente, about 10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stir in half of the Cheddar and Monterey jack cheeses and all of the green onions. Season with salt and pepper. Serve, topped with the remaining cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("With the infused flavors of ginger, lemongrass, and basil, this traditional yellow curry is both fragrant and sweet and will appeal to milder palates. Choose a hotter curry powder if you like more of a kick. Serve the curry over steamed jasmine rice")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "id": "a-14"
    }
  }, [_vm._v("CHICKEN & COCONUT CURRY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-14"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Tbsp canola oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 lb (1.5 kg) skinless, bone-in chicken thighs")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 shallots, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Tbsp Madras-style curry powder")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp firmly packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 lemongrass stalks, center white part only, cut into 1-inch (2.5-cm) pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1-inch (2.5-cm) piece peeled fresh ginger, cut into 4 slices")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (8 fl oz/250 ml) chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 can (13½ fl oz/420 ml) unsweetened coconut milk")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp Asian fish sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 carrots, cut into 1-inch (2.5-cm) chunks")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 sweet potato, about¾ lb (375 g), peeled and cut into 1-inch (2.5-cm) chunks")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Tbsp finely sliced fresh basil")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large, heavy pot, heat the oil over medium-high heat. Working in batches, sear the chicken until nicely browned, about 4 minutes per side. Transfer to a plate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the garlic and shallots to the pot and sauté just until fragrant, about 30 seconds. Add the curry powder, brown sugar, red pepper flakes, 1 tsp black pepper, the lemongrass, and the ginger and sauté until the spices are fragrant and well blended with the garlic and shallots, about 30 seconds. Add the broth and stir to scrape up any browned bits on the pot bottom. Stir in the coconut milk and fish sauce and bring to a boil. Add the chicken, carrots, and sweet potato, and stir to cover them in the mixture. Partially cover and cook over low heat until the chicken is opaque throughout and the vegetables are very tender, about 1 hour. Garnish with the basil and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a15"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A mix of colorful beets, deep green arugula, and snowy white cheese can brighten the usually cool, gray days of January. Be careful when working with red beets, as their juice can stain your fingers, countertop, and cutting board. Rinse fingers or work surfaces immediately with water, and use lemon juice to remove persistent stains")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a15"
    }
  }), _c('a', {
    attrs: {
      "id": "a-15"
    }
  }, [_vm._v("ROASTED BEETS WITH BABY ARUGULA & RICOTTA SALATA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-15"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 beets of any color, about 1 lb (500 g) total")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 Tbsp (2 fl oz/60 ml) olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp fresh orange juice")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp fresh lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ tsp Dijon mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cups (2 oz/60 g) wild or baby arugula, tough stems removed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4–5 oz (125–155 g) ricotta salata cheese, crumbled")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 350°F (180°C).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If the greens are still attached to the beets, remove them, leaving 1 inch (2.5 cm) of the stem intact. Place the beets in a small roasting pan and rub with 1½ Tbsp of the oil. Roast the beets, turning once or twice, until tender when pierced with a fork, 1–1¼ hours. Let cool. Peel the beets and cut into thin wedges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a bowl, using a fork, mix together the orange and lemon juices, the remaining 2½ Tbsp oil, the mustard, ½ tsp salt, and ¼ tsp pepper. Add the sliced beets to the bowl and turn gently to coat with the dressing. Add the arugula and toss until well mixed. Top with the ricotta salata and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "a-15"
    }
  }), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p20.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Unlike many fish cakes that are loaded with fillers, these crisp salmon patties are nearly all fish, with just a little ginger and green onions for flavor. Serve them with steamed bok choy and brown rice for a healthy weeknight dinner")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "id": "a-16"
    }
  }, [_vm._v("SALMON CAKES WITH GINGER & GREEN ONION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-16"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp coarsely chopped fresh ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 green onions, white and pale green parts, coarsely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) wild salmon fillet, skin removed, cut into small pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp cornstarch")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 large egg white")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp Asian fish sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp canola oil, or as needed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp sesame seeds, toasted")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Low-sodium soy sauce, for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sriracha sauce, for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lime, cut into wedges")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a food processor, combine the ginger and green onions and process until finely chopped, stopping once or twice to scrape down the sides of the work bowl. Sprinkle the salmon with the cornstarch and add to the processor with the egg white, a pinch of salt, and the fish sauce. Using quick pulses, process until the mixture resembles coarsely ground meat. Do not overprocess or the cakes will be heavy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Divide the salmon mixture into 8 equal portions. With moistened hands, gently shape each portion into a patty about ½ inch (12 mm) thick. Transfer to a plate, cover with plastic wrap, and refrigerate for 5–10 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large frying pan over medium heat, warm the 1 Tbsp oil. Add the salmon cakes and cook until golden brown on the first side, about 3 minutes. Turn, adding more oil if needed, and cook until the cakes are slightly springy to the touch and have lost their raw color in the center, 2–3 minutes longer. Transfer to plates and sprinkle with the sesame seeds. Serve, passing the soy sauce, Sriracha sauce, and lime wedges at the table.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a17"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Broccoli is often combined with potatoes to make a thick, flavorful soup, and cheese, especially Cheddar, is a favorite addition. Using blue cheese instead of Cheddar shifts the flavor slightly toward the tangy side but keeps the creamy texture. This is a good soup for serving with crackers, including breaking a few into the pot to make it even thicker and richer")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a17"
    }
  }), _c('a', {
    attrs: {
      "id": "a-17"
    }
  }, [_vm._v("POTATO & BROCCOLI SOUP WITH BLUE CHEESE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-17"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Tbsp unsalted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (2½ oz/75 g) chopped shallots")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) Yukon Gold potatoes, cubed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ lb (750 g) broccoli, tough stems peeled, florets and stems coarsely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Tbsp all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 cups (32 fl oz/1 l) chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ lb (125 g) blue cheese, crumbled")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large, heavy pot, melt the butter over medium-high heat. When it foams, add the shallots and cook, stirring occasionally, until limp, about 1 minute. Stir in the potatoes and broccoli. Sprinkle with ½ tsp salt, ¼ tsp pepper, and the flour and stir until the flour is incorporated, about 1 minute. Add about ½ cup (4 fl oz/125 ml) of the broth, stirring to make a paste, then gradually add the remaining broth and bring to a boil. Reduce the heat to medium-low and simmer until the potatoes and broccoli stems are fork-tender, about 15 minutes. Let cool slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Working in batches, purée the soup in a food processor or blender. Return the soup to the pot, place over medium-high heat, and bring to a simmer. Sprinkle in half of the cheese and stir until it melts, about 1 minute. Serve with the remaining cheese on the side.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "a-17"
    }
  }), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p23.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Both vegetarians and carnivores will find this meatless main dish a satisfying choice for a cool winter evening. You can use any mushrooms in the mix and substitute spinach or kale for the chard. The Cheddar cheese infuses the polenta with a nutty flavor; Parmesan or fontina would be a good choice, as well")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('a', {
    attrs: {
      "id": "a-18"
    }
  }, [_vm._v("POLENTA WITH WILD MUSHROOMS, CHARD & CHEDDAR CHEESE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-18"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sea salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ cups (10½ oz/330 g) polenta")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 bunches chard, tough stems removed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 fresh rosemary sprig, about 6 inches (15 cm) long")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 Tbsp (2 oz/60 g) unsalted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp minced shallots")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) assorted wild mushrooms such as chanterelles, porcini, morels, or lobster mushrooms, coarsely cut or left whole depending on size")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (4 oz/125 g) shredded or crumbled white Cheddar cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a saucepan over high heat, bring 8 cups (64 fl oz/2 l) water and 1½ tsp salt to a boil. Slowly add the polenta, stirring constantly. Reduce the heat to low and cook, stirring often, until the polenta pulls away from the sides of the pan, about 40 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, bring a large pot of water to a boil over high heat. Add the chard leaves and rosemary sprig. Reduce the heat to medium and cook until the chard ribs are easily pierced with a fork, about 10 minutes. Drain well. Chop coarsely and squeeze dry. Set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a frying pan over medium-high heat, warm the oil with 1 Tbsp of the butter. Add the shallots and mushrooms and cook until the mushrooms are tender, 8–10 minutes. Using a slotted spoon, transfer to a bowl. Reserve the juices.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When the polenta is ready, stir in the remaining 3 Tbsp butter, all but ¼ cup (1 oz/30 g) of the cheese, 1 tsp salt, and 1 tsp pepper and cook until the butter and cheese have melted, 3–4 minutes longer. Return the frying pan used for the mushrooms to medium-high heat. Warm the reserved juices, then add the chard and mushrooms and cook, stirring, until hot and well coated. Season with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spoon the polenta into a large serving bowl, top with the chard and mushrooms, sprinkle with the remaining cheese, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a19"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Warm up on cold days with spicy Latin flavors. Spanish-style chorizo adds robust flavor to this stew, which is extra satisfying because of the double dose of protein from the beans and the meat")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a19"
    }
  }), _c('a', {
    attrs: {
      "id": "a-19"
    }
  }, [_vm._v("SPICY RED BEAN & CHORIZO STEW")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-19"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2¼ cups (1 lb/500 g) dried red kidney beans, picked over and rinsed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp canola oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 large yellow onion, finely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 celery ribs, finely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 green bell pepper, seeded and chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 cups (32 fl oz/1 l) beef or chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 tsp red wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½–¾ tsp red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) cured Spanish-style chorizo, cut into slices¼ inch (6 mm) thick")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hot-pepper sauce, such as Tabasco")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cooked white rice for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Place the beans in a large bowl with cold water to cover and soak for at least 4 hours or up to overnight. (For a quick soak, combine the beans and water to cover in a large pot, bring to a boil, remove from the heat, cover, and soak for 1 hour.) Drain and rinse the beans.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large, heavy frying pan, heat the oil over medium-high heat. Add the onion, celery, and bell pepper and sauté until softened and just beginning to brown, about 6 minutes. Add the garlic, season with salt and black pepper, and cook for 1 minute. Pour in 1 cup (8 fl oz/250 ml) of the broth and stir to scrape up any browned bits on the pan bottom. Transfer the contents of the pan to a slow cooker and stir in the drained beans, remaining 3 cups (24 fl oz/750 ml) broth, the vinegar, red pepper flakes to taste, bay leaves, and chorizo. Cover and cook on the low setting for 6–8 hours, stirring once or twice. The beans should be very tender.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Discard the bay leaves. Season with salt, black pepper, and Tabasco. If desired, using the back of a spoon, mash some of the beans against the inside of the cooker to thicken the stew.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spoon rice into shallow bowls, top with the stew, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Here, chicken, vegetables, and rice noodles are cooked in a clear, spice-infused broth. An abundance of bright green garnishes liven up this one-dish meal. The more of them you add, the healthier and more flavorful this soup becomes")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('a', {
    attrs: {
      "id": "a-20"
    }
  }, [_vm._v("ASIAN-STYLE CHICKEN SOUP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-20"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8 cups (64 fl oz/2 l) low-sodium chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 bunch green onions, plus thinly sliced green onions for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2-inch (5-cm) piece fresh ginger, peeled and sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp Asian fish sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("each")]), _vm._v(" star anise pods and cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1–1¼ lb (500–625 g) skinless, boneless chicken breasts")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Thai chiles, or 1 serrano chile, thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bean sprouts, basil sprigs, cilantro sprigs, and lime wedges for serving")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hoisin sauce (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 heads baby bok choy")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6–7 oz (185–220 g) dried rice stick noodles")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large pot over high heat, combine the broth and 2 cups (16 fl oz/500 ml) water. Cut the green onion bunch in half crosswise and add to the pot; add the ginger, fish sauce, and sugar. In a tea ball, combine the star anise and cloves; add to the pot. Bring the broth to a boil. Add the chicken breasts, return to a boil, reduce the heat to medium-low, and simmer until the chicken is cooked through, 10–15 minutes. Using tongs, transfer the chicken to a plate. Continue to simmer the broth to develop the flavor, 15–30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the sliced green onions, sliced chiles, bean sprouts, herb sprigs, lime wedges, and hoisin sauce, if using, on a platter and set on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Slice the bok choy crosswise about ½ inch (12 mm) thick. Thinly slice the chicken breasts crosswise. In a large bowl, soak the noodles in very hot water for 3 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove the green onions and ginger from the broth and discard. Season the broth to taste with salt and pepper. Add the bok choy, raise the heat to high, and bring to a boil. Drain the noodles, add them to the broth, and cook until just tender, about 2 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Using tongs, divide the noodles and bok choy among 4 warmed deep bowls. Divide the chicken among the bowls. Ladle the broth over the top. Serve, allowing diners to add the condiments to taste.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a21"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Filled with a rich, tangy lemon pudding lightened up with whipped cream, lemon chiffon pie is a timeless dessert that will brighten any winter table. Here, it has been updated with a spicy gingersnap crust. A sealable plastic bag and a rolling pin make short work of crushing the cookies into crumbs")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a21"
    }
  }), _c('a', {
    attrs: {
      "id": "a-21"
    }
  }, [_vm._v("LEMON CHIFFON GINGERSNAP PIE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-21"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1¼ cups (4 oz/125 g) gingersnap cookie crumbs")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5 Tbsp (2½ oz/75 g) unsalted butter, melted")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ cup (6 oz/185 g) plus 3 Tbsp granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2¼ tsp (1 package) unflavored powdered gelatin")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("⅛ tsp kosher salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ cup (6 fl oz/180 ml) fresh lemon juice, strained")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp finely grated orange zest")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 large egg yolks, lightly beaten")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1¼ cups (10 fl oz/310 ml) heavy cream")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (1 oz/30 g) confectioners’ sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 350°F (180°C). In a bowl, stir together the crumbs, butter, and 3 Tbsp granulated sugar until the crumbs are evenly moistened. Pat the crumb mixture firmly and evenly into the bottom and all the way up the sides of a 9-inch (23-cm) pie pan or dish. Bake until the crust is firm, 5–7 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour ¼ cup (2 fl oz/60 ml) cold water into a saucepan and sprinkle with the gelatin. Let stand until the gelatin softens and swells, 5–10 minutes. Stir in the ¾ cup granulated sugar, salt, lemon juice, orange zest, and egg yolks; the mixture will be lumpy. Cook over medium heat, stirring continuously, until the gelatin melts and the mixture thickens, 6–8 minutes. Do not allow the mixture to boil. Set the saucepan in an ice bath until the mixture is cool to the touch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, using an electric mixer, whip the cream and confectioners’ sugar on medium-high speed until thick, soft peaks form. Spoon the whipped cream into the gelatin mixture and fold together with a rubber spatula until smooth. Pour into the prepared crust, smoothing the top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Refrigerate the pie until chilled and firm, 3–4 hours. Let stand at room temperature for 20 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The nutty flavor and delicate texture of soba noodles pair particularly well with mild napa cabbage. If napa cabbage is not in the market, bok choy or green cabbage can be substituted")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page25"
    }
  }), _c('a', {
    attrs: {
      "id": "a-22"
    }
  }, [_vm._v("STIR-FRIED SOBA NOODLES WITH BEEF & CABBAGE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-22"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) boneless beef sirloin or tenderloin, partially frozen")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) toasted sesame oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) soy sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) plus 1 Tbsp peanut oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp peeled and grated fresh ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ lb (375 g) dried soba noodles")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 large cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 green onions, including 3 inches (7.5 cm) of green tops, thinly sliced on the diagonal")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 head napa cabbage, about 2 lb (1 kg), cored and shredded")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cups (16 fl oz/500 ml) chicken or beef broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp cornstarch")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ lb (250 g) snow peas, trimmed and halved crosswise")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (1 oz/30 g) sesame seeds, lightly toasted")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Using a sharp knife, cut the beef across the grain into thin slices, then cut the slices into matchsticks. In a bowl, whisk together the sesame oil, soy sauce, ¼ cup peanut oil, and ginger. Add the beef and stir to coat evenly. Cover and refrigerate, stirring occasionally, for at least 1 hour or up to 3 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bring a large pot of water to a rapid boil. Add 2 Tbsp salt and the noodles, stir well, and cook, stirring occasionally, until just tender, 5–7 minutes. Drain the noodles.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, in a wok or large frying pan, heat the 1 Tbsp peanut oil over medium-high heat. Add the garlic and green onions and stir-fry until lightly colored, about 1 minute. Raise the heat to high, add the beef and its marinade, and stir-fry until lightly browned, about 8 minutes. Add the cabbage and 1½ cups (12 fl oz/375 ml) of the broth and toss to combine. Cover, reduce the heat to medium-high, and cook until the cabbage wilts, about 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a small bowl, whisk the cornstarch into the remaining ½ cup (4 fl oz/125 ml) broth. Add the cornstarch mixture to the pan, and stir and toss to incorporate. Add the snow peas, stir and toss to combine, cover, and cook until just tender, about 2 minutes. Take care not to overcook; the snow peas and cabbage should remain crisp.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add the noodles to the pan and stir and toss until well combined. Garnish with the toasted sesame seeds and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a23"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In this dish, the rich walnut oil, sweet brown sugar, and tart wine vinegar work together to temper the cabbagey taste of brussels sprouts, while the chestnuts add texture and flavor. Look for vacuum-packed roasted and peeled chestnuts in gourmet shops and well-stocked supermarkets")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a23"
    }
  }), _c('a', {
    attrs: {
      "id": "a-23"
    }
  }, [_vm._v("VINEGAR-GLAZED BRUSSELS SPROUTS WITH CHESTNUTS & WALNUT OIL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-23"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) brussels sprouts, trimmed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp unsalted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (8 fl oz/250 ml) chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 oz (90 g) vacuum-packed chestnuts, coarsely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp firmly packed golden brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp red wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 tsp toasted walnut oil")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a large frying pan, warm the oil over medium heat. Add the brussels sprouts in a single layer and sprinkle lightly with salt. Cook, stirring once or twice, until the sprouts are golden brown and caramelized on all sides, about 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Raise the heat to medium-high and add the butter, broth, and chestnuts. Bring the broth to a boil and stir to scrape up any browned bits on the bottom of the pan. Reduce the heat to medium-low, cover partially, and simmer until the sprouts are just tender when pierced with a knife and most of the liquid has evaporated, 20–22 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add ¼ cup (2 fl oz/60 ml) water to the pan, stir in the sugar and vinegar, and raise the heat to medium-high. Cook, stirring occasionally, until the liquid reduces to a glaze, 2–3 minutes. Remove the pan from the heat and stir in the walnut oil. Season with salt and pepper. Transfer to a bowl and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "a-23"
    }
  }), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p26.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pale yellow Chinese egg noodles, sometimes labeled lo mein, are ideal for tossing with meat and/or vegetables and a brightly flavored vinaigrette for a hearty main-course salad. If fresh Chinese noodles are unavailable, substitute dried, or used dried vermicelli from the Italian pasta shelf at the market")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('a', {
    attrs: {
      "id": "a-24"
    }
  }, [_vm._v("NOODLE SALAD WITH PORK & ASIAN LIME VINAIGRETTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-24"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 pork tenderloins, about¾ lb (375 g) each, trimmed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp peanut oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-b"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FOR THE ASIAN LIME VINAIGRETTE")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp peanut oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp soy sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Juice of 1 lime")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 tsp sherry vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp peeled and minced fresh ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("⅛ tsp sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 or 3 drops Sriracha or other hot sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-b"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) fresh Chinese egg noodles")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 red bell pepper, seeded and thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 small red serrano chile, seeded and thinly sliced crosswise (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (⅓ oz/10 g) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("each")]), _vm._v(" chopped fresh flat-leaf parsley andcilantro leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Prepare a charcoal or gas grill for direct-heat cooking over high heat, or preheat the broiler. Brush the pork tenderloins with the 1 Tbsp oil and season with salt and pepper. Place on the grill rack or on a broiler pan 4 inches (10 cm) from the heat source and cook, turning occasionally, until an instant-read thermometer inserted into the thickest part registers 150°F (65°C) or the pork is pale pink when cut in the thickest portion, about 12 minutes. Transfer to a cutting board and let rest for 2–3 minutes before carving. Cut crosswise into slices ¼ inch (6 mm) thick.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, to make the vinaigrette, in a blender, combine the 2 Tbsp oil, soy sauce, lime juice, vinegar, ginger, sugar, and Sriracha to taste. Purée until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bring a pot three-fourths full of salted water to a boil. Add the noodles, stir, and cook until just tender, according to package directions. Drain well and transfer to a large bowl. Add the bell pepper, chile (if using), vinaigrette to taste, and half each of the parsley and cilantro, and toss to mix well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transfer the noodles to bowls and arrange the pork and remaining herbs over the top. Serve warm or at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a25"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Barley has a pleasantly chewy texture and a sweet, nutty flavor. When stirred into broth over low heat, it cooks into a creamy risotto-style dish. The addition of meaty mushrooms, shredded chicken, and slightly bitter greens to the barley creates a balanced one-dish dinner")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a25"
    }
  }), _c('a', {
    attrs: {
      "id": "a-25"
    }
  }, [_vm._v("BARLEY RISOTTO WITH CHICKEN, MUSHROOMS & GREENS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-25"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 cups (48 fl oz/1.5 l) chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1½ Tbsp olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 yellow onion, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 clove garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cups (6 oz/185 g) sliced cremini mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (4 fl oz/125 ml) dry white wine")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (7 oz/220 g) pearl barley")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 cups (4 oz/125 g) bite-sized pieces Swiss chard leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cups (¾ lb/375 g) shredded cooked chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (2 oz/60 g) grated Parmesan cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a saucepan, bring the broth to a simmer over medium-high heat. Turn off the heat, cover, and keep warm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large saucepan, heat the oil over medium-high heat. Add the onion and garlic and cook, stirring frequently, until the onion is soft, about 5 minutes. Add the mushrooms, ¼ tsp salt, and a few grindings of pepper. Cook, stirring frequently, until the mushrooms release their liquid and start to brown, 4–5 minutes. Add the wine, bring to a boil, and cook for 1 minute.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add 5 cups (40 fl oz/1.25 l) of the hot broth and the barley. Cover and simmer over medium-low heat, stirring occasionally and adding more broth ¼ cup (2 fl oz/60 ml) at a time if the barley becomes dry, until the barley is tender, about 45 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stir in the Swiss chard and more broth, if necessary. Cook, uncovered, until the greens are wilted, about 2 minutes. Stir in the chicken and cook for 1 minute to heat through. Stir in the Parmesan, season with salt and pepper, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kumquats, tiny oval citrus fruits packed with flavor, are usually in season from December to March. You eat the peel as well as the flesh, as the peel is sweet and balances the tartness of the flesh. Here, kumquats are paired with the season’s sweet carrots in a puréed soup suitable for a family supper or a dinner party")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "id": "a-26"
    }
  }, [_vm._v("KUMQUAT-CARROT PURÉE WITH TOASTED FENNEL SEEDS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-26"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 tsp fennel seeds")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 Tbsp (2 oz/60 g) unsalted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 small yellow onion, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (6 oz/185 g) kumquats, unpeeled, chopped, plus kumquat slices for garnish")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 lb (1 kg) carrots, peeled and thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5 cups (40 fl oz/1.25 l) chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a small frying pan, toast the fennel seeds over medium heat just until fragrant, about 3 minutes. Transfer to a spice grinder and grind finely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large, heavy pot, melt the butter over medium-high heat. Add the onion and garlic and sauté until translucent, about 5 minutes. Add the kumquats and carrots and sauté for 10 minutes. Add the broth and bring to a boil. Reduce the heat to low and simmer, uncovered, until the carrots and kumquats are very soft, 35–40 minutes. Remove from the heat and let cool slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Working in batches, purée the soup in a blender. Return to the pot and stir in the ground fennel. Season with salt and pepper and serve, garnished with kumquat slices.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a27"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Quinoa, a gluten-free, protein-packed, grain-like seed, replaces bulgur wheat in this new riff on a Mediterranean classic. The addition of grilled shrimp makes this dish hearty enough to serve as a main course. This recipe would also be delicious with other proteins, such as grilled salmon or leftover shredded rotisserie chicken")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a27"
    }
  }), _c('a', {
    attrs: {
      "id": "a-27"
    }
  }, [_vm._v("QUINOA TABBOULEH WITH LEMONY GRILLED SHRIMP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-27"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 4–6")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 lb (500 g) shrimp, peeled and deveined")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Grated zest and juice of 1 lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (8 oz/250 g) quinoa, rinsed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 English cucumber, cut into½-inch (12-mm) pieces")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 pint (12 oz/375 g) cherry tomatoes, halved")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 green onions, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (1½ oz/45 g) chopped fresh flat-leaf parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-b"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FOR THE LEMON-GARLIC DRESSING")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 cloves garlic, minced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Juice of½ lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 fl oz/60 ml) extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Place the shrimp in a nonreactive bowl with the lemon zest and juice and the oil. Season with salt and pepper and toss to combine. Cover and refrigerate for 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bring 2 cups (16 fl oz/500 ml) water to a boil in a saucepan over medium-high heat. Add ½ tsp salt and the quinoa and reduce heat to low. Cover the saucepan and cook until the water is absorbed and the quinoa is tender, 15–20 minutes. Transfer the quinoa to a bowl and let cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Warm a stove-top grill pan over high heat. Remove the shrimp from the marinade and place on the grill pan; discard the marinade. Cook just until the shrimp are bright pink and opaque throughout, about 2 minutes per side. Transfer the shrimp to the bowl with the quinoa. Add the cucumber, tomatoes, green onions, and parsley and mix to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To make the dressing, place the garlic and lemon juice in a small bowl. Whisk in the extra-virgin olive oil and season to taste with salt and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stir the dressing into the quinoa. Season to taste with salt and pepper and serve at room temperature, or refrigerate and serve cold.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A creamy caramel sauce fills these individual tartlets. When making the caramel, be sure to watch it carefully to ensure it doesn’t burn. The addition of macadamia nuts gives these tartlets an incomparable richness. The deep golden caramel sauce is also excellent poured over ice cream or drizzled over cake")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('a', {
    attrs: {
      "id": "a-28"
    }
  }, [_vm._v("CARAMEL-MACADAMIA TARTLETS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-28"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("makes 6 tartlets")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-b"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FOR THE CREAM CHEESE TARTLET DOUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (4 oz/125 g) unsalted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 oz (90 g) cream cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-b"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (5 oz/155 g) all-purpose flour, sifted")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (4 fl oz/125 ml) heavy cream")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("⅔ cup (5 oz/155 g) sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ tsp fresh lemon juice, strained")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("⅛ tsp kosher salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¾ cup (4 oz/125 g) unsalted roasted macadamia nuts, roughly chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In the bowl of a stand mixer fitted with the paddle attachment, beat the butter and cream cheese on low speed until smooth and blended, about 45 seconds. Add the flour and mix until a smooth dough forms. Transfer the dough to a work surface and shape into a thick log. Wrap with plastic wrap and store in the refrigerator until ready to use, up to 3 days.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Cut the dough into 6 equal portions. Roll each portion into a 2-inch (5-cm) ball. Place a ball in each of six 3½-inch (9-cm) tartlet pans. Press the dough evenly over the bottom and up the sides of each pan until it is even with the rim. Remove any overhang. Freeze until the dough is firm, about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Preheat the oven to 400°F (200°C). Line the tartlets with foil and fill with pie weights. Place on a baking sheet and bake until the crusts start to look dry, about 15 minutes. Remove the weights and foil. Reduce the oven temperature to 350°F (180°C) and continue to bake until the crusts are lightly browned, about 5 minutes. Let cool on the sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, in a small saucepan, warm the cream over low heat until it registers 150°F (65°C) on an instant-read thermometer. Keep the cream over very low heat to maintain this temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large, heavy saucepan, stir the sugar, lemon juice, and 3 Tbsp water over medium heat until the sugar dissolves. Stop stirring and wash down the pan sides with a pastry brush dipped in water. Raise the heat to medium-high and bring the mixture to a boil. Boil until the sugar melts and turns a dark golden color, about 4 minutes. Watch carefully, swirling the pan occasionally to ensure that the sugar cooks evenly. Remove from the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Slowly pour the warm cream into the hot caramelized sugar. The mixture will bubble up. Return the pan to low heat, add the salt, and stir until the caramel completely dissolves and is smooth, about 1 minute. Set aside to cool and thicken slightly, about 30 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stir the nuts into the caramel. Pour the mixture into the cooled tartlet shells, dividing it evenly and filling them to just below the rim. Bake until the filling begins to bubble, 10–15 minutes. Transfer the baking sheet to a wire rack and let the tartlets cool completely before unmolding and serving.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a29"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To make this crisp salad even more refreshing, slice the fennel no more than a few minutes in advance of serving, and keep the bulbs cold until just before slicing. If fennel is sliced and left undressed, it will discolor within about 20 minutes")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a29"
    }
  }), _c('a', {
    attrs: {
      "id": "a-29"
    }
  }, [_vm._v("FENNEL SALAD WITH BLOOD ORANGES & ARUGULA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-29"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 fennel bulbs, trimmed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp red wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 Tbsp (3 fl oz/90 ml) extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 cups (4 oz/125 g) loosely packed arugula leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 blood or navel oranges, peeled with a knife and sliced crosswise into thin slices")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Halve the fennel bulbs lengthwise and, using a mandoline or a very sharp knife, cut the halves crosswise into paper-thin slices.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a large bowl, whisk together the vinegar, ¼ tsp salt, and ¼ tsp pepper. Add the oil in a thin stream, whisking constantly until the dressing is smooth. Add the arugula and fennel and toss to coat evenly with the vinaigrette. Mound the mixture on a platter, distribute the orange slices over and around the salad, and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "a-29"
    }
  }), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p31.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Traditional")]), _vm._v(" tarte tatin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("uses apples and a classic pastry crust, but this delicious variation substitutes pears and flaky puff pastry. Crystallized ginger packs a gentle heat and plays against the pears’ sweet, floral flavor. Serve wedges of this festive tart with dollops of cr è me fra î che")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('a', {
    attrs: {
      "id": "a-30"
    }
  }, [_vm._v("SPICED PEAR TARTE TATIN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-30"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6–8")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ sheet frozen puff pastry (about½ lb/250 g), thawed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 Tbsp (2 oz/60 g) unsalted butter, at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ cup (2 oz/60 g) granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 firm, ripe pears, peeled, halved, and cored")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ cup (3½ oz/105 g) firmly packed light brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Tbsp finely chopped crystallized ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("½ tsp ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("¼ tsp freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Tbsp fresh lemon juice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 400°F (200°C). On a lightly floured work surface, roll out the pastry into an 11-inch (28-cm) round about ¼ inch (6 mm) thick. Trim the edges, then chill until ready to use.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spread 2 Tbsp of the butter over the sides and bottom of a 10-inch (25-cm) round ovenproof frying pan. Sprinkle the granulated sugar evenly over the bottom, then place the pears, cut side up, in a tight layer in the pan. Cook over medium heat until the pears start to release their juices, about 10 minutes. In a bowl, stir together the brown sugar, ginger, cinnamon, and nutmeg. Sprinkle over the pears along with the lemon juice. Dot the top with the remaining 2 Tbsp butter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Top the pears with the pastry, tucking the edges into the pan to form a rim that encircles the pears. Prick the top with a fork.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake until the crust is golden brown, the pears are tender, and a thickened golden syrup forms in the pan, about 45 minutes. Let stand for 5 minutes. Run a knife around the inside edge of the pan. Invert the tart onto a plate, dislodging and replacing any pears that may have stuck to the pan. Serve.")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a31"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Woodsy thyme pairs beautifully with the hearty flavors of winter ingredients. Here, it seasons brown lentils, which star in a richly textured and colored salad that also features thinly sliced kale, roasted carrots, sautéed onions, and crisp bacon")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "a31"
    }
  }), _c('a', {
    attrs: {
      "id": "a-31"
    }
  }, [_vm._v("WARM LENTIL & KALE SALAD WITH BACON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "a-31"
    }
  }, [_c('p', {
    staticClass: "hang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("serves 6")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 small carrots, finely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 Tbsp (2 fl oz/60 ml) olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Salt and freshly ground pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 large red onion, thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 large bunch kale, ribs removed, leaves thinly sliced")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 large cloves garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10 fresh thyme sprigs")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 cup (7 oz/220 g) brown lentils, picked over and rinsed")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 cups (32 fl oz/1 l) chicken broth")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 slices bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 tsp sherry vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Preheat the oven to 400°F (200°C). Line a baking sheet with foil. Place the carrots on the prepared sheet, drizzle with 2 Tbsp of the oil, sprinkle with ¾ tsp salt and ¼ tsp pepper, and toss to coat. Spread the carrots out evenly. Roast, stirring once or twice, until tender, about 15 minutes. Let cool to room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, in a frying pan, warm the remaining 2 Tbsp oil over medium heat. Add the onion, ¼ tsp salt, and several grinds of pepper and sauté until the onion is soft and lightly caramelized, about 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bring a saucepan of water to a boil. Add 1 Tbsp salt and the kale and cook until tender, about 6 minutes. Drain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the garlic and thyme on a square of cheesecloth, bring the corners together, and secure with kitchen string. In the same saucepan used to cook the kale, combine the lentils, broth, ½ tsp salt, ¼ tsp pepper, and the cheesecloth bundle. Bring to a boil, reduce the heat to medium, and simmer, uncovered, until the lentils are tender but not mushy, 15–20 minutes. In a frying pan, cook the bacon over medium heat, turning once, until crisp and browned, about 7 minutes. Transfer to paper towels to drain. Let cool and then coarsely chop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Drain the lentils and discard the cheesecloth bundle. Transfer to a bowl. Stir in the cooked kale, the vinegar, and ½ tsp salt. Top with the carrots, onion, and bacon, and serve.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-833b135e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cap01.vue
// module id = 69
// module chunks = 0